module.exports = __webpack_public_path__ + "static/media/atemi_logo.ce426ad6.png";